import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isCreatingFaculty: false,
  isDeletingFaculty: false,
  isEditingFaculty: false,
  faculties: [],
};

export const facultiesSlice = createSlice({
  name: "faculties",
  initialState,
  reducers: {
    getFacultiesStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getFacultiesSuccess: (state, action) => {
      state.isLoading = false;
      state.faculties = action.payload;
      state.error = null;
    },
    getFacultiesFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createFacultyStart: (state, action) => {
      state.isCreatingFaculty = true;
      state.error = null;
    },
    createFacultySuccess: (state, action) => {
      state.isCreatingFaculty = false;
      state.error = null;
    },
    createFacultyFailure: (state, action) => {
      state.isCreatingFaculty = false;
      state.error = action.payload;
    },
    editFacultyStart: (state, action) => {
      state.isEditingFaculty = true;
      state.error = null;
    },
    editFacultySuccess: (state, action) => {
      state.isEditingFaculty = false;
      state.error = null;
    },
    editFacultyFailure: (state, action) => {
      state.isEditingFaculty = false;
      state.error = action.payload;
    },
    deleteFacultyStart: (state, action) => {
      state.isDeletingFaculty = true;
      state.error = null;
    },
    deleteFacultySuccess: (state, action) => {
      state.isDeletingFaculty = false;
      state.error = null;
    },
    deleteFacultyFailure: (state, action) => {
      state.isDeletingFaculty = false;
      state.error = action.payload;
    },
  },
});

export const {
  getFacultiesFailure,
  getFacultiesSuccess,
  getFacultiesStart,
  createFacultyFailure,
  createFacultyStart,
  createFacultySuccess,
  editFacultyFailure,
  editFacultyStart,
  editFacultySuccess,
  deleteFacultyFailure,
  deleteFacultyStart,
  deleteFacultySuccess

} = facultiesSlice.actions;

const facultiesReducer = facultiesSlice.reducer;
export default facultiesReducer;
